// Validation check fields for GroupToBusinessRoleGrid (Type 5)
export const validationCheckFields = [
    { key: 'validation_ActionType', label: 'Action Type' },
    {
        key: 'validation_ApplicationIdentifier',
        label: 'Application Identifier',
    },
    {
        key: 'validation_ApplicationRoleIdentifier',
        label: 'Application Role Identifier',
    },
    { key: 'validation_LocationIdentifier', label: 'Location Identifier' },
    {
        key: 'validation_BusinessRoleIdentifier',
        label: 'Business Role Identifier',
    },
]

